const ONETRUST_UPDATE_EVENT = "OneTrustGroupsUpdated";
var w$2 = typeof window !== "undefined" ? window : void 0;
const OneTrustLoaded = () => typeof w$2?.OptanonWrapper !== "undefined" && typeof w$2?.OnetrustActiveGroups !== "undefined";
const isConsented = (cookieGroup, description) => {
  if (!description) {
    console.warn("Please provide a description of why you need this script.");
  }
  const activeGroups = consentedCookieGroups();
  if (Array.isArray(cookieGroup)) {
    return cookieGroup.every((group) => activeGroups.includes(group));
  } else {
    return activeGroups.some((group) => group === cookieGroup);
  }
};
const onceConsented$1 = (cookieGroup, description) => {
  return new Promise((resolve) => {
    const callback = () => {
      if (isConsented(cookieGroup, description)) {
        try {
          w$2?.removeEventListener(ONETRUST_UPDATE_EVENT, callback);
          resolve();
        } catch (e) {
          console.warn(`b2x-cookie-consent failed executing consent callback`, e);
        }
      }
    };
    if (w$2 && isConsented(cookieGroup, description) && OneTrustLoaded()) {
      resolve();
    } else {
      w$2?.addEventListener(ONETRUST_UPDATE_EVENT, callback);
    }
  });
};
const consentedCookieGroups = () => {
  const groups = document.cookie.split(";").find((x) => x.trim().startsWith("consentedCookieGroups="))?.split("=")[1];
  if (!groups) {
    return [];
  }
  const decodedGroups = decodeURIComponent(groups)?.split(",");
  return decodedGroups.filter((group) => !!group);
};
const onceConsented = (cookieGroup, description) => onceConsented$1(cookieGroup, description);

const w$1 = typeof window !== "undefined" ? window : void 0;
const isMyBusinessDomain = (hostname) => {
  return hostname === "mybusiness.telia.se" || hostname.endsWith(".mybusiness.telia.se");
};
const isTeliaAtWorkDomain = (hostname) => {
  return hostname === "telia-at-work.telia.se" || hostname.endsWith(".telia-at-work.telia.se");
};
const isUnderTestTelia = (hostname) => {
  return hostname.endsWith(".test.telia.se") || hostname.endsWith(".test.mybusiness.telia.se") || hostname.endsWith(".test.telia-at-work.telia.se");
};
const rule = (url) => {
  return {
    /** True if the URL is considered a dev/test environment (e.g. *.test.telia.se or window.ENVIRONMENT === "legacy-dev"). */
    isDev: isDev(url),
    /** True if the URL is a production environment (www.telia.se, telia.se, mybusiness.telia.se, telia-at-work.telia.se). */
    isProd: isProd(url),
    /** True if the URL targets the B2B segment — either via a B2B domain (mybusiness/telia-at-work) or a pathname starting with /foretag. */
    isB2B: isB2B(url),
    /** True if the URL does not target the B2B segment. Inverse of isB2B. */
    isB2C: isB2C(url),
    /** True if the URL is publicly accessible (not behind login). Inverse of isPrivate. */
    isPublic: isPublic(url),
    /** True if the URL requires authentication — B2B domains (mybusiness/telia-at-work) or paths under /mitt-telia, /privat/mitt-telia, /foretag/mybusiness, /foretag/telia-at-work. */
    isPrivate: isPrivate(url),
    /** Returns true if the pathname ends with any of the given segments. */
    pathEndsWith: (segments) => endsWith(segments, url),
    /** Returns true if the pathname starts with any of the given segments. */
    pathStartsWith: (segments) => startsWith(segments, url),
    /** Returns true if the pathname contains any of the given substrings. */
    pathIncludes: (segments) => includes(segments, url),
    /** Returns true if the pathname matches any of the given regular expressions. */
    pathMatches: (regexps) => matches(regexps, url),
    /** Returns true if the pathname is an exact string match with any of the given strings. */
    pathMatchesExact: (strings) => matchesExact(strings, url)
  };
};
const isDev = (url) => {
  const hostname = url.hostname;
  if (isUnderTestTelia(hostname)) {
    return true;
  }
  if (typeof w$1?.ENVIRONMENT !== "undefined" && w$1?.ENVIRONMENT === "legacy-dev") {
    return true;
  }
  if (isMyBusinessDomain(hostname) || isTeliaAtWorkDomain(hostname)) {
    return false;
  }
  if (hostname === "www.telia.se" || hostname === "telia.se") {
    return false;
  }
  return true;
};
const isProd = (url) => {
  const hostname = url.hostname;
  if (isUnderTestTelia(hostname)) {
    return false;
  }
  if (hostname === "www.telia.se" || hostname === "telia.se") {
    return true;
  }
  return isMyBusinessDomain(hostname) || isTeliaAtWorkDomain(hostname);
};
const isB2B = (url) => {
  const hostname = url.hostname;
  if (isMyBusinessDomain(hostname) || isTeliaAtWorkDomain(hostname)) {
    return true;
  }
  return url.pathname?.startsWith("/foretag");
};
const isB2C = (url) => !isB2B(url);
const isPrivate = (url) => {
  const hostname = url.hostname;
  if (isMyBusinessDomain(hostname) && !startsWith(["/foretag/bredband/"], url)) {
    return true;
  }
  if (isTeliaAtWorkDomain(hostname)) {
    return true;
  }
  return startsWith(
    ["/privat/mitt-telia", "/mitt-telia", "/foretag/mybusiness", "/foretag/telia-at-work"],
    url
  );
};
const isPublic = (url) => !isPrivate(url);
const startsWith = (segment, url) => segment.some((pathname) => url.pathname.startsWith(pathname));
const endsWith = (segment, url) => segment.some((pathname) => url.pathname.endsWith(pathname));
const includes = (segment, url) => segment.some((pathname) => url.pathname.includes(pathname));
const matches = (regexps, url) => regexps.some((pattern) => pattern.test(url.pathname));
const matchesExact = (strings, url) => strings.some((str) => str === url.pathname);

const w = typeof window !== "undefined" ? window : void 0;
const toggles = {
  ["analytics-log" /* ANALYTICS_LOG */]: false
};
const isEnabled = (feature) => w ? typeof toggles[feature] !== "undefined" && !!w.localStorage?.getItem(`ft-${feature}`) : false;
const logEnabled = () => isEnabled("analytics-log" /* ANALYTICS_LOG */);
const snakeCase = (str) => str.toLocaleLowerCase().replace(/ /g, "_");
const convertToSnakeCase = (obj) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => convertToSnakeCase(item));
  }
  const snakeCaseObj = {};
  for (const key in obj) {
    if (typeof obj[key] === "string") {
      snakeCaseObj[key] = snakeCase(obj[key]);
    } else {
      snakeCaseObj[key] = convertToSnakeCase(obj[key]);
    }
  }
  return snakeCaseObj;
};
const getBCSessionID = () => {
  if (!w || typeof w.document === "undefined") {
    return "";
  }
  const cookies = w.document.cookie;
  const match = cookies.match(/(?:^|;\s*)BCSessionID=([^;]*)/);
  return match ? match[1] : "";
};

async function consentedTrack(eventName, eventParams, dataLayer) {
  return onceConsented("C0003", "Event tracking").then(() => {
    const eventObject = {
      event: eventName,
      ...convertToSnakeCase(eventParams)
    };
    if (logEnabled()) {
      console.table(eventObject);
    }
    dataLayer.push(eventObject);
    return;
  });
}
const getBusinessArea = (url) => {
  return url.pathname.startsWith("/foretag") || url.pathname.startsWith("/en/business") ? "b2b" : "b2c";
};
const getPageType = (url) => {
  const r = rule(url);
  const pageType = "unknown";
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/?$/]) || r.pathMatchesExact(["/", "/foretag"])) {
    return "start";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/bestall/]) || r.pathMatches([
    /^\/foretag\/bredband\/(?:anpassa|bekraftelse|bestall|kassa|organisationsval|till-kassan)/
  ])) {
    return "order";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/hantera/])) {
    return "manage";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/fakturor/])) {
    return "invoices";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/support/])) {
    return "support";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/installningar/])) {
    return "settings";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/release-notes/])) {
    return "article";
  }
  if (r.pathStartsWith(["/sok", "/foretag/sok"])) {
    return "search";
  }
  if (r.pathStartsWith(["/formular", "/foretag/formular"])) {
    return "form";
  }
  if (r.pathMatches([/^\/foretag\/telia-at-work\/support/])) {
    return "support";
  }
  if (r.pathMatches([/^\/foretag\/telia-at-work/])) {
    return "subscription";
  }
  if (r.pathStartsWith(["/foretag/support"])) {
    return "support";
  }
  if (r.pathStartsWith(["/foretag/mer-fran-telia"])) {
    return "about";
  }
  if (r.pathStartsWith(["/foretag/artiklar"])) {
    return "article";
  }
  if (r.pathStartsWith(["/foretag/erbjudanden"])) {
    return "campaign";
  }
  if (r.pathStartsWith(["/foretag/utloggad"])) {
    return "sessionend";
  }
  if (r.pathStartsWith(["/foretag/mybusiness/skaffa-mybusiness"])) {
    return "registration";
  }
  return pageType;
};
const getPagesegment = (url) => {
  const r = rule(url);
  let pageSegment = "open_pages";
  if (typeof url.pathname === "undefined") {
    return "";
  }
  if (r.pathStartsWith(["/foretag/mybusiness"])) {
    pageSegment = "mybusiness";
  } else if (r.pathStartsWith(["/mitt-telia", "/privat/mitt-telia"])) {
    pageSegment = "mitt_telia_web";
  } else if (r.pathStartsWith(["/support", "/foretag/support", "/kontakt"])) {
    pageSegment = "open_pages_support";
  } else if (r.pathStartsWith(["/foretag/telia-at-work"])) {
    pageSegment = "telia_at_work";
  }
  return pageSegment;
};

const queuedEvents = [];
const TRIGGER_EVENT_NAME = "custom_pageview";
let awaitingPageview = false;
function beginPageview() {
  awaitingPageview = true;
}
function isMyBusinessPage() {
  return w?.location.pathname.startsWith("/foretag/mybusiness");
}
function isTrackingEnabled() {
  return !!w?.trackingEnabled;
}
function enableTracking() {
  if (w) {
    w.trackingEnabled = true;
  }
}
function isLoggedInAvailable() {
  return typeof w?.loggedIn === "boolean";
}
function isTrackingReady() {
  return isTrackingEnabled() && isLoggedInAvailable();
}
function shouldQueueEvent() {
  return (awaitingPageview || !isTrackingReady()) && !isMyBusinessPage();
}
function setLoggedInStatus(status) {
  if (w) {
    w.loggedIn = status;
  }
  if (isTrackingEnabled()) flushQueue();
}
function handleEventQueuing(eventName, eventParams) {
  if (eventName === TRIGGER_EVENT_NAME) {
    queuedEvents.unshift({ event: eventName, ...eventParams });
    flushQueue();
    enableTracking();
    awaitingPageview = false;
  } else {
    queuedEvents.push({ event: eventName, ...eventParams });
  }
}
function trackEventImmediately(eventName, eventParams) {
  const eventData = isMyBusinessPage() ? eventParams : { ...eventParams, logged_in: w?.loggedIn };
  consentedTrack(eventName, eventData, w.dataLayer);
}
function track(eventName, eventParams) {
  if (!w) {
    return;
  }
  w.dataLayer = w.dataLayer || [];
  if (shouldQueueEvent()) {
    handleEventQueuing(eventName, eventParams);
    return;
  }
  trackEventImmediately(eventName, eventParams);
}
function flushQueue() {
  if (!isTrackingReady()) return;
  queuedEvents.forEach(({ event, ...eventParams }) => {
    if (w?.dataLayer) {
      consentedTrack(event, { ...eventParams, logged_in: w.loggedIn }, w.dataLayer);
    }
  });
  queuedEvents.length = 0;
}
const getDefaultEventParameters = (url) => ({
  page_type: getPageType(url),
  page_segment: getPagesegment(url),
  business_area: getBusinessArea(url),
  bc_session_id: getBCSessionID()
});

export { beginPageview, getDefaultEventParameters, setLoggedInStatus, track };
//# sourceMappingURL=b2x-google-analytics.esm.js.map
